import React, { useState } from 'react'
import { FormattedMessage, useIntl } from 'react-intl'
import { List } from '@gympass/yoga'
import { Radio, RadioGroup } from '@material-ui/core'

import { UnitedStatesRoundedFlag, BrazilRoundedFlag } from '@assets/icons'

import useInternationalization from '@hooks/useInternationalization'

import TabbedContainer from '@components/TabbedContainer'

import env from '@config/env'

import * as Style from './CountryLanguageDialog.style'

function CountryLanguageDialog() {
  const intl = useIntl()

  const { country, language } = useInternationalization()

  const [selectedCountry, setSelectedCountry] = useState(country)
  const [selectedLanguage, setSelectedLanguage] = useState(language)

  function handleCountry({ target: { value } }) {
    setSelectedCountry(value)
  }

  function handleLanguage({ target: { value } }) {
    setSelectedLanguage(value)
  }

  function handleSubmit() {
    const url =
      env.contextRoot === '/'
        ? `${env.contextRoot}${selectedCountry}?lang=${selectedLanguage}`
        : `${env.contextRoot}/${selectedCountry}?lang=${selectedLanguage}`

    window.location.href = url
  }

  return (
    <TabbedContainer>
      <Style.TabWrapper
        label={
          intl.messages['smb_acquisition_language_panel.section.country.title']
        }
      >
        <Style.ListWrapper>
          <RadioGroup value={selectedCountry} onChange={handleCountry}>
            <List>
              <Style.ListItem>
                <Style.CountryIcon
                  src={BrazilRoundedFlag}
                  alt="Rounded brazilian country flag"
                />
                <Style.FormControlLabel
                  label={
                    <Style.ListItemText>
                      <FormattedMessage id="smb_acquisition_commons.countries.brazil" />
                    </Style.ListItemText>
                  }
                  value="br"
                  labelPlacement="start"
                  control={<Radio />}
                />
              </Style.ListItem>

              <Style.ListItem>
                <Style.CountryIcon
                  src={UnitedStatesRoundedFlag}
                  alt="Rounded American country flag"
                />
                <Style.FormControlLabel
                  label={
                    <Style.ListItemText>
                      <FormattedMessage id="smb_acquisition_commons.countries.united_states" />
                    </Style.ListItemText>
                  }
                  value="us"
                  labelPlacement="start"
                  control={<Radio />}
                />
              </Style.ListItem>
            </List>
          </RadioGroup>
        </Style.ListWrapper>

        <Style.TabButton onClick={handleSubmit}>
          <FormattedMessage id="smb_acquisition_language_panel.call_to_actions.apply" />
        </Style.TabButton>
      </Style.TabWrapper>

      <Style.TabWrapper
        label={
          intl.messages['smb_acquisition_language_panel.section.language.title']
        }
      >
        <Style.ListWrapper>
          <RadioGroup value={selectedLanguage} onChange={handleLanguage}>
            <List>
              <Style.ListItem>
                <Style.FormControlLabel
                  label={
                    <Style.ListItemText>
                      <FormattedMessage id="smb_acquisition_commons.languages.pt_br" />
                    </Style.ListItemText>
                  }
                  value="pt"
                  labelPlacement="start"
                  control={<Radio />}
                />
              </Style.ListItem>

              <Style.ListItem>
                <Style.FormControlLabel
                  label={
                    <Style.ListItemText>
                      <FormattedMessage id="smb_acquisition_commons.languages.en_us" />
                    </Style.ListItemText>
                  }
                  value="en"
                  labelPlacement="start"
                  control={<Radio />}
                />
              </Style.ListItem>
            </List>
          </RadioGroup>
        </Style.ListWrapper>

        <Style.TabButton onClick={handleSubmit}>
          <FormattedMessage id="smb_acquisition_language_panel.call_to_actions.apply" />
        </Style.TabButton>
      </Style.TabWrapper>
    </TabbedContainer>
  )
}

export default CountryLanguageDialog
